import * as React from "react";
const SvgTick = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 36", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.925 25.233L42.225.935l5.399 5.4-29.699 29.698-1.35-1.35-16.199-16.2 5.4-5.399 12.15 12.15z", fillRule: "evenodd" }));
export default SvgTick;
